import { SettingElementConfig } from '@/game/GameComponents/PhaserGame/Types/UITypes/SettingsPanelTypes';
import RadioButton from '@/game/prefabs/RadioButton/RadioButton';
import SettingToggle from '@/game/prefabs/SettingToggle/SettingToggle';

export default class SettingElement {
  constructor(config: SettingElementConfig) {
    this.key = config.key;
    this.element = config.element;
    this.settingLabel = config.settingLabel;
    this.tooltipBacking = config.tooltipBacking;
    this.tooltipText = config.tooltipText;
    this.helpIcon = config.helpIcon;
    this.settingTooltip = config.settingTooltip;
  }

  public key: string = '';

  element: RadioButton | SettingToggle;
  settingLabel: Phaser.GameObjects.BitmapText;
  tooltipBacking: Phaser.GameObjects.NineSlice;
  tooltipText: Phaser.GameObjects.BitmapText;
  helpIcon: Phaser.GameObjects.Image;
  settingTooltip: Phaser.GameObjects.Container;

  setTooltipVisible(visible: boolean) {
    // Never show a blank tooltip.
    if (visible && this.tooltipText.text === '') {
      return;
    }
    this.settingTooltip.setVisible(visible);
  }

  updateTooltip(tooltip?: string) {
    this.tooltipText.text = tooltip ?? '';
    if (tooltip) {
      const backingScale = this.tooltipBacking.scaleX;
      const padding = 8;
      const helpIconBounds = this.helpIcon.getBounds();
      this.tooltipBacking.width =
        (this.tooltipText.getBounds().width + helpIconBounds.width) /
          backingScale +
        padding;
      this.tooltipBacking.height =
        this.tooltipText.getBounds().height / backingScale + padding;
      const textBounds = this.settingLabel.getBounds();
      const xMargin = 8;
      this.settingTooltip.setX(
        textBounds.width + this.settingLabel.x + xMargin,
      );
      this.settingTooltip.setY(this.settingLabel.y - 16);
      this.helpIcon.setY(this.tooltipBacking.getBounds().height / 2);
    }
  }

  setSetting(
    key: string,
    value: boolean,
    setting?: string,
    tooltip?: string,
    isInteractive: boolean = true,
  ) {
    this.key = key;
    this.settingLabel.text = setting ?? this.settingLabel.text;
    this.element.controller.makeInteractive(isInteractive);
    this.element.controller.setSelected(value);
    this.updateTooltip(tooltip);
  }
}
